import {
  optionalText,
  toSelectFilter,
} from "~/pages/Directory/shared/filterHelpers";
import { IPartnersFilterForm } from "~/pages/Partners/PartnersFilter";

export type IPartnersUrlParams = {
  page?: number | string;
  count?: number | string;
  sortField?: string;
  sortType?: string;
  openModal?: string;
  currentId?: string;
  id?: string;
  name?: string;
  inn?: string;
  status?: string;
  createdFrom?: string;
  createdTo?: string;
  country?: string;
  fo?: string;
  region?: string;
  city?: string;
  author?: string;
};

export const parsePartnersFilterFromUrl = (
  params: IPartnersUrlParams,
): IPartnersFilterForm => ({
  id: optionalText(params.id),
  name: optionalText(params.name),
  inn: optionalText(params.inn),
  status:
    params.status === "all"
      ? null
      : (toSelectFilter(params.status) ?? {
          value: "Активный",
          label: "Активный",
        }),
  createdFrom: params.createdFrom ? new Date(params.createdFrom) : null,
  createdTo: params.createdTo ? new Date(params.createdTo) : null,
  country: toSelectFilter(params.country),
  fo: toSelectFilter(params.fo),
  region: toSelectFilter(params.region),
  city: toSelectFilter(params.city),
  author: optionalText(params.author),
});
